<article class="message">
    <core-helper-box-header-user-date [date]="message.feedback.approval.date" [user]="message.feedback.user" [feedback]="message.feedback">
    </core-helper-box-header-user-date>
    <div class="approval-box-action">
        <figure *ngIf="message.feedback.approval.status_code == 1" class="action-icon approve-ico"></figure>
        <figure *ngIf="message.feedback.approval.status_code == 2" class="action-icon reject-ico"></figure>
        <div class="content">
        <div class="message-text" [innerHTML]="message.feedback.approval.message"></div>
        </div>
    </div>

</article>
